export default {"src":"/_next/static/media/wave-tools.33e72770.svg","height":720,"width":849,"blurWidth":0,"blurHeight":0};